import React, { useState } from 'react';
import parse from 'html-react-parser';

import './styles.scss';
import { __t } from '../../../../../../base/utils/t';
import { ClickTooltip } from '../../../../../../base/components/ClickTooltip';
import { Icon } from '../../../../../../base/components/Icon';
import { removeAllHTMLTags } from '../../../../../../base/utils';

interface Props {
    responseId: number;
    description: string;
    descriptionTranslated: string;
    translateHandler: (responseId: number) => void;
    markNewResponseAsReadHandler: () => void;
}

export const WorkerDescription = ({
    responseId,
    description,
    descriptionTranslated,
    translateHandler,
    markNewResponseAsReadHandler,
}: Props) => {
    const [showTranslation, setShowTranslation] = useState(false);

    const translationButtonClickHandler = () => {
        setShowTranslation(true);
        if (!descriptionTranslated) {
            translateHandler(responseId);
        }
    };

    return (
        <div className='responses-table-worker-description'>
            <div className='responses-table-worker-description__text'>{removeAllHTMLTags(description)}</div>

            <ClickTooltip
                className='responses-table-worker-description__modal'
                wrapperClassName='responses-table-worker-description__show-more-link-wrapper'
                align='left'
                activeButton={
                    <div
                        onClick={markNewResponseAsReadHandler}
                        className='responses-table-worker-description__show-more-link'
                    >
                        {__t('Показати повністю')}
                    </div>
                }
                closeTooltipCallback={() => setShowTranslation(false)}
            >
                <>
                    <div className='responses-table-worker-description__modal-text'>
                        {parse(showTranslation && descriptionTranslated ? descriptionTranslated : description)}
                    </div>
                    {showTranslation ? (
                        <div
                            className='responses-table-worker-description__translate-button'
                            onClick={() => setShowTranslation(false)}
                        >
                            <Icon
                                icon='language-regular'
                                color='info'
                                size='14px'
                                className='responses-table-worker-description__translate-icon'
                            />
                            {__t('Показати оригінал')}
                        </div>
                    ) : (
                        <div
                            className='responses-table-worker-description__translate-button'
                            onClick={translationButtonClickHandler}
                        >
                            <Icon
                                icon='language-regular'
                                color='info'
                                size='14px'
                                className='responses-table-worker-description__translate-icon'
                            />
                            {__t('Перекласти текст')}
                        </div>
                    )}
                </>
            </ClickTooltip>
        </div>
    );
};
